module.exports = "https://www.gc-pro.gnp.com.mx/178588220fc4fe31aebd1d895ab4147e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/registro-exitoso.png
// module id = 8162
// module chunks = 0